import React from "react";
import "./Payer.less";

export default class PaymentRedirect extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      redirect: false,
    }
    this.timer = null  
  }


  componentDidMount() {
    this.timer = setTimeout(() => {
      this.setState({
        redirect: true,
      });
    }, 10000);
  }
  componentWillMount() {
   clearTimeout(this.timer)
 }
  render() {
    if (this.state.redirect) {
      return window.location.replace(this.props.redirectUrl);
    }
    else 
    return <div/>;
  }
}



// WEBPACK FOOTER //
// ./src/modules/Payer/PaymentRedirect.js